import BaseListagem from "components/BaseListagem";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Column } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import CondicaoPagamentoService from "service/fiscal/CondicaoPagamentoService";
import { filterApplyTemplate, TextMatchModeOptions } from "utils/filterUtils";

const condicaoPagamentoService = new CondicaoPagamentoService();

export default function CondicaoPagamentoListagem() {
    const defaultFilters: DataTableFilterMeta = {
        codigoInterno: { constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }], operator: FilterOperator.AND },
        descricao: { constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }], operator: FilterOperator.AND }
    };

    return (
        <BaseListagem ordenacao="codigoInterno,ASC" service={condicaoPagamentoService} urlService="/condicaoPagamento"
            tituloPagina="Condições de pagamento" defaultFilters={defaultFilters} showClearFilterButton nome="condicaoPagamento">
            <Column field="codigoInterno" header="Código" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
            <Column field="descricao" header="Descrição" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
            <Column field="ativa" header="Ativo" body={(rowData) => rowData.ativa ? "Sim" : "Não"} />
        </BaseListagem>
    );
}
